export default "__VITE_ASSET__DWHci6jp__"